import React, { useState, useMemo, useCallback, useEffect } from 'react'
import { Expander, ExpanderHeader, ExpanderContent, Separator } from '@fs/zion-ui'
import { usePermission } from '@fs/zion-permissions'
import { useGroupData } from '../../../../hooks'
import ReworkHistoryItems from './ReworkHistoryItems'
import ReworkButtons from './ReworkButtons'
import transl from './ReworkFolder.transl'

export default function ReworkFolder() {
  const [authorized] = usePermission('LightyearRequestReworkPermission', 'LightyearContext')
  const {
    group: { imageRework = {}, currentWorkflowActions = [] },
  } = useGroupData()

  const canShowButton = (workflow) => workflow.name === 'SupervisorAuditReview' && workflow.status === 'Completed'
  const [reworkHistory, setReworkHistory] = useState([])
  const [allHistory, setAllHistory] = useState([])
  const showReworkButton = useMemo(() => currentWorkflowActions?.some(canShowButton), [currentWorkflowActions])

  useEffect(() => {
    // We want to only keep Cancelled/Available CameraRework items and other RequestCameraRework actions
    // to reduce repetition in displaying states. We can deduce state based on the rework item in this way:
    // RequestCameraRework = "Available" => Requested
    // CameraRework = "Available" => Approved
    // RequestCameraRework = "Cancelled"  || CameraRework = "Cancelled" => Canceled

    if (imageRework?.history?.length > 0) {
      const filteredHistory = imageRework.history.filter((item) => {
        return !['Completed', 'In Progress'].includes(item?.state)
      })
      setReworkHistory(filteredHistory)
      setAllHistory(imageRework?.history || [])
    }
  }, [imageRework, currentWorkflowActions])

  const addReworkItem = useCallback(
    (newItem) => {
      setReworkHistory([...reworkHistory, newItem])
      setAllHistory([...allHistory, newItem])
    },
    [reworkHistory, allHistory]
  )

  return (
    <>
      {(authorized && showReworkButton) || reworkHistory?.length > 0 ? (
        <Expander>
          <ExpanderHeader>{transl.folderRework()}</ExpanderHeader>
          <ExpanderContent>
            <Separator size="xxs" />
            <ReworkHistoryItems {...{ reworkHistory }} />
            <ReworkButtons {...{ reworkHistory: allHistory, addReworkItem }} />
          </ExpanderContent>
        </Expander>
      ) : null}
    </>
  )
}
